module.exports = __webpack_public_path__ + "docusign-logo-modal.png?96368cbc6c3b9458a5b279a1a589d967";